var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22536 5.00468C5.63712 5.55521 4.83876 5.86525 4.00571 5.86666C5.06559 5.86807 6.08154 6.26203 6.83045 6.96201C7.57936 7.662 8 8.61077 8 9.59999V11.7333C8 11.8748 7.9398 12.0104 7.83263 12.1105C7.72547 12.2105 7.58012 12.2667 7.42857 12.2667H6.49029H1.50971H0.571429C0.419876 12.2667 0.274531 12.2105 0.167368 12.1105C0.0602039 12.0104 0 11.8748 0 11.7333V9.59999C0 8.61077 0.420642 7.662 1.16955 6.96201C1.91846 6.26203 2.93441 5.86807 3.99429 5.86666C3.16124 5.86525 2.36288 5.55521 1.77464 5.00468C1.18639 4.45415 0.856387 3.70817 0.857144 2.93067C0.857902 2.15316 1.18936 1.40774 1.77867 0.85821C2.36799 0.30868 3.16696 0 4 0C4.83304 0 5.63201 0.30868 6.22133 0.85821C6.81064 1.40774 7.1421 2.15316 7.14286 2.93067C7.14361 3.70817 6.81361 4.45415 6.22536 5.00468Z",
    fill: "#718FBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.85b783d36b98126f6a1f964c82f431e7.svg";
export { ForwardRef as ReactComponent };